function createInstance() {
  const { sessionData } = useSessionData()
  const features = reactive(sessionData.featureflags)

  const api = useApi()

  async function setFeatureAsync(key, value) {
    await api.updateFeatureFlagValue(key, value)
    features[key] = value
  }

  // if (!readOnly) {
  //   watch(features, async (value) => {
  //     console.log(value.customer_v2_calendar_user_toggle, prevValue.customer_v2_calendar_user_toggle)
  //     const key = Object
  //       .keys(value)
  //       .find(key => value[key] !== prevValue[key])
  //     console.log({ key })
  //     if (!key)
  //       return

  //     console.log('here')

  //     const updatedValue = value[key]

  //     try {
  //       await api.updateFeatureFlagValue(key, updatedValue)
  //       prevValue = { ...value }
  //     }
  //     catch (e) {
  //       features[key] = prevValue[key]
  //     }
  //   })
  // }

  return { features, setFeatureAsync }
}

export const useFeatures = useSingleton(createInstance)
